module.exports = __webpack_public_path__ + "media/images/game_icon/en/BC4056-873a0b316ea01ed6bbf9921865be2699.png";